module.exports = __webpack_public_path__ + "static/media/efs_minsk_map_motorway.c46c84db.jpg";